export default {
  regex: '^[a-zA-Z0-9 !@#$&*()\\-_+=`~.,:;<>/?\'"]*$',
  message: 'Sign name is not valid',
  requiredMessage: 'Name is required',
};
